import { RevenueByPage } from './revenue-by-page';

export { RevenueByPage };
